import { keyframes, useTheme } from "@emotion/react";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import CountUp from "react-countup";

export default function StatsSctCard({
  setHoveredIndex,
  hoveredIndex,
  index,
  stat,
  hasAnimated,
}) {
  const theme = useTheme();

  // animation
  const float = keyframes`
    0% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0px); }
  `;

  const pulse = keyframes`
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.1); opacity: 0.8; }
    100% { transform: scale(1); opacity: 1; }
  `;

  const shine = keyframes`
    0% { background-position: -100% }
    100% { background-position: 200% }
  `;

  const borderGlow = keyframes`
    0% { border-color: rgba(255,255,255,0.1); box-shadow: 0 0 0px rgba(255,255,255,0); }
    50% { border-color: rgba(255,255,255,0.3); box-shadow: 0 0 20px rgba(255,255,255,0.2); }
    100% { border-color: rgba(255,255,255,0.1); box-shadow: 0 0 0px rgba(255,255,255,0); }
  `;

  return (
    <Grid
      sx={{ p: { xs: ".6rem", sm: "1rem" } }}
      size={{ xs: 6, sm: 6, lg: 3 }}
    >
      <Box
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
        sx={{
          p: 3,
          textAlign: "center",
          height: "100%",
          borderRadius: 4,
          position: "relative",
          overflow: "hidden",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255,255,255,0.2)",
          cursor: "pointer",
          animation: `${borderGlow} 3s ease-in-out infinite`,
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: stat.bgGradient,
            opacity: 0.1,
            transition: "opacity 0.4s ease",
            zIndex: 0,
          },
          "&::after": {
            content: '""',
            position: "absolute",
            top: "-50%",
            left: "-50%",
            width: "200%",
            height: "200%",
            background:
              "linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent)",
            transform: "rotate(45deg)",
            animation: `${shine} 3s ease-in-out infinite`,
          },
          "&:hover": {
            transform: "translateY(-12px) scale(1.02)",
            boxShadow: `0 20px 40px rgba(0,0,0,0.3), 0 0 20px ${stat.color}`,
            "&::before": {
              opacity: 0.2,
            },
          },
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            color: stat.color,
            mb: 2,
            animation: `${float} 2s ease-in-out infinite`,
            position: "relative",
            zIndex: 1,
            "& svg": {
              filter: `drop-shadow(0 0 10px ${stat.color})`,
              transition: "filter 0.3s ease",
            },
          }}
        >
          {stat.icon}
        </Box>

        {/* Count Up */}
        <Typography
          variant="h4"
          component="div"
          sx={{
            fontWeight: "bold",
            mb: 1,
            position: "relative",
            zIndex: 1,
            background: stat.bgGradient,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            fontSize: { xs: "1.5rem", sm: "2.5rem", md: "2.2rem" },
            transition: "all .3s",
          }}
        >
          {hasAnimated ? (
            <CountUp
              start={0}
              end={stat.value}
              duration={2.5}
              suffix={stat.suffix}
              separator=","
              enableScrollSpy={false}
              delay={index * 0.2}
            />
          ) : (
            `0${stat.suffix}`
          )}
        </Typography>

        {/* Label*/}
        <Typography
          variant="subtitle1"
          sx={{
            position: "relative",
            zIndex: 1,
            color: "text.disabled",
            fontWeight: 500,
            transition: "all 0.3s ease",
            display: "inline-block",
            fontSize: { xs: ".9rem" },
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -4,
              left: "50%",
              transform: "translateX(-50%) scaleX(1)", // همیشه نمایش داده شود
              width: "100%",
              height: "2px",
              background: stat.bgGradient,
              transition: "transform 0.3s ease",
            },
          }}
        >
          {stat.label}
        </Typography>
      </Box>
    </Grid>
  );
}
